import React, { useContext } from 'react';
import Proptypes from 'prop-types';
import {
  Card,
  CardBody,
  CardTitle,
  Typography,
  Badge
} from '@one-thd/sui-atomic-components';
import { Document } from '@one-thd/sui-icons';
import { AddToContext } from '../../AddToContext';
import { SCREENS, TRACK } from '../../AddToConstants';
import { triggerAnalytics } from '../../AddToHelpers';

export const MODEL_NAME = 'starterListTile';

/**
 * Tile component for using starter lists
 */
export const StarterListTile = ({ isVertical = false }) => {
  const { setScreen } = useContext(AddToContext);

  const handleClick = () => {
    // 10.1 AI Entry Points - Track starter list entry point click
    triggerAnalytics(TRACK.LIST_BUILDER_ENTRY_POINT_CLICK, {
      entryPoint: SCREENS.STARTER_LISTS.toLocaleLowerCase().split('_').join(' ')
    });
    setScreen(SCREENS.STARTER_LISTS);
  };

  if (isVertical) {
    return (
      <div
        onClick={handleClick}
        role="presentation"
        data-testid="starter-list-tile"
        className="sui-w-full sui-mt-2"
      >
        <Card
          role="button"
          disablePadding
          disableGutters
          orientation="horizontal"
          aria-label="Use a starter list for common projects"
        >
          <div className="sui-w-24 sui-flex sui-justify-center sui-items-center">
            <Document size="large" color="primary" />
          </div>
          <div className="sui-py-3 sui-pr-1">
            <CardTitle
              header={(
                <Typography
                  variant="h3"
                  color="primary"
                >
                  Use a Starter List
                </Typography>
              )}
            />
            <CardBody>
              <Typography>
                Customize a template with your materials
              </Typography>
            </CardBody>
          </div>
        </Card>
      </div>
    );
  }

  return (
    <div onClick={handleClick} role="presentation" data-testid="starter-list-tile" className="sui-h-full">
      <Card
        role="button"
        PaperProps={{ className: 'sui-h-full' }}
        aria-label="Use a starter list for common projects"
      >
        <CardBody>
          <Typography variant="h6" weight="bold">
            Use a Starter List
          </Typography>
          <Badge variant="regular" color="info" size="small">
            Beta
          </Badge>
          <div className="sui-mt-1">
            <Typography variant="body-sm" color="subtle">
              Customize a template with your materials
            </Typography>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

StarterListTile.propTypes = {
  isVertical: Proptypes.bool
};

StarterListTile.defaultProps = {
  isVertical: false
};

StarterListTile.displayName = 'StarterListTile';

export default StarterListTile;
